(function () {
  'use strict';

  /* @ngdoc object
   * @name baseWiseLayoverReport
   * @description
   *
   */
  angular
    .module('baseWiseLayoverReport', [
      'ui.router'
    ]);
}());
